import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  formWrapper: {
    position: 'relative'
  },
  BasicInfoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      minWidth: 200,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      [theme.breakpoints.up('sm')]: {
        margin: 0,
        minHeight: 40,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
        display: 'flex',
        alignItems: 'center',
        paddingRight: theme.spacing(2)
      }
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#f3f3f3'
    },
    '& .MuiFormControl-root': {
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    }
  },
  autocompleteWrapper: {
    position: 'relative',
    width: '100%'
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 1000,
    maxHeight: 300,
    overflow: 'auto',
    marginTop: theme.spacing(0.5),
    boxShadow: theme.shadows[3]
  },
  menuItem: {
    padding: theme.spacing(1.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  userName: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.text.primary
  },
  userEmail: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  },
  selectedUsersBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: `${theme.spacing(1)}px`,
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    minHeight: 50
  },
  userChip: {
    margin: theme.spacing(0.5)
  },
  SubmitRow: {
    padding: theme.spacing(4, 0),
    textAlign: 'center'
  },
  AddAdminSubmit: {
    color: theme.palette.common.white,
    background: theme.palette.primary.light,
    border: 'none',
    padding: theme.spacing(1, 6),
    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.7
    },
    '&:hover, &:focus': {
      opacity: 0.7
    }
  },
  usersNoResultsText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    textAlign: 'center'
  },
  PromocodeRulesTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(26),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(4),
  },
  singleRuleWrapper: {
    backgroundColor: theme.palette.secondary.light,
    padding: `${theme.spacing(2)}px ${theme.spacing(2.5)}px`,
    marginBottom: theme.spacing(2.5)
  },
  PromocodeSingleRuleTitle: {
    color: theme.colors.grey,
    fontSize: theme.typography.pxToRem(26),
    fontWeight: theme.typography.fontWeightMedium
  },
  ruleAccordion: {
    marginBottom: theme.spacing(2),
    '&:before': {
      display: 'none'
    },
    '&.Mui-expanded': {
      margin: `${theme.spacing(2)}px 0`
    }
  },
  accordionSummary: {
    backgroundColor: theme.palette.secondary.light,
    '&.Mui-expanded': {
      minHeight: 48
    },
    '& .MuiAccordionSummary-content': {
      margin: `${theme.spacing(1.5)}px 0`,
      '&.Mui-expanded': {
        margin: `${theme.spacing(1.5)}px 0`
      }
    }
  },
  accordionDetails: {
    display: 'block',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper
  },
  removeWrapper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
    display: 'flex',
    justifyContent: 'flex-end'
  },
  removeRecord: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  },
  clearPayableButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  },
  AddNewRecord: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: '100%'
  },
  payablesManagerWrapper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  payablesTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(22),
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: theme.spacing(2)
  },
  payableCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`
  },
  payableCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  payableCardTitle: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium
  },
  removePayableButton: {
    padding: theme.spacing(0.5),
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.common.white
    }
  },
  payableCardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(2)}px`
  },
  payableField: {
    display: 'flex',
    flexDirection: 'column',
    '& .MuiInputLabel-root': {
      marginBottom: theme.spacing(1),
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium
    }
  },
  noPayablesText: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontStyle: 'italic'
  },
  addPayableButton: {
    marginTop: theme.spacing(1)
  },
  payableAutocompleteWrapper: {
    display: 'flex',
    flexGrow: 1,
    gap: `${theme.spacing(1)}px`,
  },
  priceChip: {
    display: 'flex',
    gap: `${theme.spacing(0.5)}px`,
    '& strong': {
      display: 'flex',
      gap: `${theme.spacing(0.5)}px`,
    }
  }
}))